<!-- Side by side toggleable buttons -->
<template>
    <q-btn-toggle
        :model-value="modelValue"
        :options="toggleOptions"
        toggle-color="accent"
        clearable
        no-caps
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: [Boolean, String, Number],
    options: Array,

    // The property of each provided option to use as the display label
    optionLabel: {
        type: String,
        default: 'value',
    },

    // The property of each provided option to use as the value binding
    optionValue: {
        type: String,
        default: 'id',
    },

    optionIcon: String,
})

defineEmits(['update:modelValue'])

const toggleOptions = computed(() => {
    return props.options.map(option => ({
        label: trans(option[props.optionLabel]),
        value: option[props.optionValue],
        icon: option[props.optionIcon],
    }))
})
</script>
